// Here is a list of the toolbar
// Detail list see https://www.tinymce.com/docs/advanced/editor-control-identifiers/#toolbarcontrols

const toolbar = ['bold italic underline strikethrough alignleft aligncenter alignright outdent indent blockquote pastetext undo redo removeformat', 'hr bullist numlist link preview anchor table forecolor backcolor fullscreen fontsizeselect']

export default toolbar
